import storageService from 'top20common/distribution/services/storage';
import companiesModule from 'top20common/distribution/store/modules/companies';
import jobModule from 'top20common/distribution/store/modules/job';
import referralPotentialBonus from 'top20common/distribution/store/modules/referral-potential-bonus';
import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';

import actions from './actions';
import getters from './getters';
import moduleManage from './modules/manage';
import moduleRegister from './modules/register';
import mutations from './mutations';
import state from './state';

Vue.use(Vuex);

const vuexLocalStorage = new VuexPersist({
  key: 'store',
  storage: window.localStorage,
  reducer: state => ({
    moduleRegister: state.moduleRegister
  }),
  filter: mutation => {
    return mutation.type === 'mutateCandidateRegisterForm' || mutation.type === 'clearCandidateRegisterForm';
  }
});

const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: {
    moduleRegister: moduleRegister,
    moduleManage: moduleManage,
    jobState: jobModule,
    companiesState: companiesModule,
    referralPotentialBonusState: referralPotentialBonus
  },
  plugins: [vuexLocalStorage.plugin, storageService.getCommonStorage().plugin]
});

if (module.hot) {
  module.hot.accept(['./mutations', './actions', './getters.js'], () => {
    store.hotUpdate({
      mutations: require('./mutations').default,
      actions: require('./actions').default,
      getters: require('./getters').default
    });
  });
}

export default store;
